import {Typography} from 'components/Typography';
import Link from 'next/link';
import React, {FC} from 'react';
import style from './style.module.scss';

interface IProps {
    title: string;
    url: string;
}

export const FilterLink: FC<IProps> = ({title, url}) => {
    return (
        <Link className={style.main} href={url}>
            <Typography variant={'label-14-r-fluid'}>{title}</Typography>
        </Link>
    );
};
